import { render, staticRenderFns } from "./viewItem.vue?vue&type=template&id=330ed0f6&"
import script from "./viewItem.vue?vue&type=script&lang=js&"
export * from "./viewItem.vue?vue&type=script&lang=js&"
import style0 from "./viewItem.vue?vue&type=style&index=0&id=330ed0f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports